import AccountService from '~/services/account'

/**
 * 公用方法库
 */
export default {

    /**
     * 生成一个隐藏 iframe 实现导出文件
     * @param url
     * @param params
     */
    exportFile(url, params) {

        let iframeDom = document.createElement("iframe");
        let reqUrl = url + '?';
        let _params = [];

        params['access-token'] = AccountService.getAccessTokenByCache();
        
        for (var key in params) {
            let value = params[key];
            // 过滤空对象
            if (value == 'undefined' || value == undefined) {
                value = '';
            }

            if (value instanceof  Array) {
                value.forEach((_value, _key) => {
                    _params.push([key + '[]', encodeURIComponent(_value)].join('='))
                })
            } else {
                _params.push([key, encodeURIComponent(value)].join('='))
            }
        }

        let str = _params.join('&');
        iframeDom.width = 0;
        iframeDom.height = 0;
        iframeDom.src = reqUrl + str;
        iframeDom.style.display = "none";
        document.body.appendChild(iframeDom);
    },
}


// WEBPACK FOOTER //
// ./src/common/functions.js